import "../../blinkist-web-design-system/system";

import "/services/airbrake";

import "/services/cookiebot";

import "/modules/auth";

import initCookieBanner from "/features/cookie-banner/init";
import featureFlags from "/utils/feature-flags";

if (featureFlags.enabled("custom_cookie_consent")) {
  initCookieBanner();
}
